// @ts-nocheck
import {AnyAction, createSlice} from '@reduxjs/toolkit';
import * as actionTypes from './uiActionTypes';

import {FixMe, UiState, UiTheme} from '@greenkub-fronts/shared/interface';
import initEnvironnement from './useCases/initEnvironnement/init-environnement.use-case';

export const UI_FEATURE_KEY = 'ui';

const sidebarReducerInit = (): UiState => {
  try {
    const stored = localStorage.getItem('sidebar');
    const tunnelSidebarIsOpenStored = localStorage.getItem('tunnelSidebar');
    const alertStored = localStorage.getItem('alertbar');
    return {
      sideBarIsOpen: stored === 'true',
      tunnelSidebarIsOpen: tunnelSidebarIsOpenStored === 'true',
      alertBarIsOpen: alertStored !== 'false',
      isCrm:
        import.meta.env.VITE_CRM_URL === import.meta.env.VITE_CURRENT_FRONT_URL,
      isCustomerArea:
        import.meta.env.VITE_CUSTOMER_AREA_URL ===
        import.meta.env.VITE_CURRENT_FRONT_URL,
      currentTheme: UiTheme.GK,
    };
  } catch {
    localStorage.setItem('sidebar', 'false');
    localStorage.setItem('tunnelSidebar', 'true');
    localStorage.setItem('alertbar', 'true');
    return {
      sideBarIsOpen: false,
      tunnelSidebarIsOpen: true,
      alertBarIsOpen: true,
      isCrm:
        import.meta.env.VITE_CRM_URL === import.meta.env.VITE_CURRENT_FRONT_URL,
      isCustomerArea:
        import.meta.env.VITE_CUSTOMER_AREA_URL ===
        import.meta.env.VITE_CURRENT_FRONT_URL,
      currentTheme: UiTheme.GK,
    };
  }
};

export const initialUiState: UiState = sidebarReducerInit();

const uiSlice = createSlice({
  name: UI_FEATURE_KEY,
  initialState: initialUiState,
  reducers: {
    toggleSidebar(state: UiState, action) {
      if (state.currentTheme === UiTheme.GEKA) {
        state.sideBarIsOpen = false;
      } else {
        if (action.payload) {
          state.sideBarIsOpen = action.payload.value;
        } else {
          state.sideBarIsOpen = !state.sideBarIsOpen;
        }
      }
    },
    toggleTunnelSidebar(state: UiState, action) {
      if (action.payload) {
        state.tunnelSidebarIsOpen = action.payload.value;
      } else {
        state.tunnelSidebarIsOpen = !state.tunnelSidebarIsOpen;
      }
    },
    alertBar(state: UiState, action) {
      if (action?.payload?.value) {
        state.alertBarIsOpen = action.payload.value;
      } else {
        state.alertBarIsOpen = !state.alertBarIsOpen;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionTypes.SET_CURRENT_THEME, (state: UiState, action: AnyAction) => {
        state.currentTheme = action['payload'].currentTheme;
      })
      .addCase(initEnvironnement.fulfilled, (state: UiState, action: AnyAction) => {
        state.isCrm = action['payload'].isCrm;
        state.isCustomerArea = action['payload'].isCustomerArea;
      });
  },
});

export const toggleSideBar = (action?: any): any => {
  return async (dispatch: any) => {
    const toggleSidebarInLocalStorage = async (action: any) => {
      const stored = localStorage.getItem('sidebar') === 'false' ? 'true' : 'false';
      localStorage.setItem('sidebar', stored);
      return !stored; // work by sending opposite but should not, strange
    };
    let respData;
    try {
      respData = await toggleSidebarInLocalStorage(action);
      dispatch(uiSlice.actions.toggleSidebar(respData));
    } catch (error) {
      console.info(error);
    } finally {
      return respData;
    }
  };
};

export const toggleTunnelSidebar = (action?: any): any => {
  return async (dispatch: any) => {
    const toggleTunnelSidebarInLocalStorage = async (action: any) => {
      const stored = localStorage.getItem('tunnelSidebar') === 'false' ? 'true' : 'false';
      localStorage.setItem('tunnelSidebar', stored);
      return !stored; // work by sending opposite but should not, strange
    };
    let respData;
    try {
      respData = await toggleTunnelSidebarInLocalStorage(action);
      dispatch(uiSlice.actions.toggleTunnelSidebar(respData));
    } catch (error) {
      console.info(error);
    } finally {
      return respData;
    }
  };
};

export const alertBar = (action: any): any => {
  return async (dispatch: any) => {
    const alertBarInLocalStorage = async (action: any) => {
      const alertStored =
        localStorage.getItem('alertbar') === 'false' ? 'true' : 'false';
      localStorage.setItem('alertbar', alertStored);
      return !alertStored; // work by sending opposite but should not, strange
    };
    let respData;
    try {
      respData = await alertBarInLocalStorage(action);
      dispatch(uiSlice.actions.alertBar(respData));
    } catch (error) {
      console.info(error);
    } finally {
      return respData;
    }
  };
};

export const ui = uiSlice.reducer;

export const uiActions: FixMe = uiSlice.actions;
